import React from 'react';
import DyButton from '../../../components/GlobalComponents/DyButton/DyButton';

interface NodeLabelProps {
  className: string;
  nodeData: {
    name: string;
    type:string;
    score:any;
  };
}



class NodeLbl extends React.PureComponent<NodeLabelProps> {
  render() {
    const { className, nodeData } = this.props;
    return (
      <div
        className={className}
        style={{
          // background: nodeData.type === 'tenant' ? '#ffc978' : nodeData.type === 'team' ? '#d5f7d4' : nodeData.type === 'objective' ? '#FFF8D0' : '#FFEEE5' ,
          background: nodeData.score>= 70 ?'#d5f7d4' : nodeData.score <70 && nodeData.score > 30 ? '#FFF8D0': nodeData.score === null ?'white' : '#FFEEE5 ',
        //   bgcolor={score>= 70 ?'#d5f7d4' : score <70 && score > 30 ? '#FFF8D0': '#FFEEE5 '}
        //   color={score>= 70 ?'#125610' : score <70 && score > 30 ? '#6B6440': '#993600 '}
          height: '100px',
          width:'182px',
          fontWeight:'700',
          alignItems:'center',
          overflow:'auto',
        //   borderTop: '5px solid #00387C',
          border: nodeData.score>= 70 ? '2px solid #125610' : nodeData.score <70 &&  nodeData.score > 30 ? '2px solid #6B6440' :
          nodeData.score === null ?'2px solid #00387C' : '2px solid #993600' ,
           color: nodeData.score>= 70 ?'#125610' :  nodeData.score <70 &&  nodeData.score > 30 ? '#6B6440':nodeData.score === null ?'black' : '#993600 ',
          textAlign: 'center',
          zIndex: '1000',
          fontSize:'13px',
          boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.4)',
          borderRadius: '20px',
          display:'flex',
          flexDirection:'row',
          justifyContent:'center'
        }}
      >
        {nodeData.name} - امتیاز:{nodeData.score}
      </div>
    );
  }
}

export default NodeLbl;